import { _ as _sliced_to_array } from "@swc/helpers/_/_sliced_to_array";
import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { Core } from "@faire/design-tokens";
import { getWindowOrThrow } from "@faire/web--source/common/globals/getWindow";
import { useStrictLocalization } from "@faire/web--source/common/localization";
import { moneyOrZero } from "@faire/web--source/common/money";
import { Button } from "@faire/web--source/slate/Button";
import { Column } from "@faire/web--source/slate/Layout";
import { Spacer } from "@faire/web--source/slate/spacing";
import { Typography } from "@faire/web--source/slate/Typography";
import { useDoActionWhenVisible } from "@faire/web--source/ui/hooks/useDoActionWhenVisible";
import { StrictLocalMsg } from "@faire/web--source/ui/lib/localization";
import { ResponsiveContentV2 } from "@faire/web--source/ui/ResponsiveContentV2";
import { QueryParameters } from "@faire/web-api--source/api/product/subscribed/retailerToken/back-in-stock/get";
import { useQuery as useQuerySubscribedBackInStock } from "@faire/web-api--source/api/product/subscribed/retailerToken/back-in-stock/get-hooks";
import { trackCartAddToCartWebCujClick, trackCartAddToCartWebCujClickTraceUalComplete } from "@faire/web-api--source/events/cart/click/addToCartWebCuj";
import { IProduct } from "@faire/web-api--source/indigofair/data/IProduct";
import { observer } from "mobx-react";
import * as React from "react";
import { useEffect, useState } from "react";
import styled from "styled-components";
import { useZustandLocation } from "@faire/retailer-visitor-shared/app/_lib/routing/useZustandLocation";
import { LazySamplesRequestModal } from "@faire/retailer/components/Modals/SamplesRequestModal/LazySamplesRequestModal";
import { SamplesRequestStoreProvider } from "@faire/retailer/components/Modals/SamplesRequestModal/SamplesRequestStore";
import { TrackedLinkContext } from "@faire/retailer/components/TrackedLink";
import { AddToCartNotificationFinished } from "@faire/retailer-visitor-shared/events";
import { useFaireDirectBrand } from "@faire/retailer/hooks/FaireDirect/useFaireDirectBrand/useFaireDirectBrand";
import { getIsBrandPreview } from "@faire/retailer-visitor-shared/lib/getIsBrandPreview";
import { useIsLoggedInRetailer, useIsLoggedInRetailerOrBrandPreview } from "@faire/retailer-visitor-shared/lib/isLoggedInRetailer";
import { useSettingFaireDirectPDPSignup } from "@faire/retailer/settings/useSettingFaireDirectPDPSignup";
import { useMarketStore } from "@faire/retailer-visitor-shared/stores/domain/Events/FaireMarkets/MarketStore";
import { useFaireProtection } from "@faire/retailer/stores/domain/FaireProtection/useFaireProtection";
import { getRetailerToken } from "@faire/retailer-visitor-shared/stores/domain/RetailerStore";
import { DesktopFaireDirectPerksCard } from "@faire/retailer/views/product/Components/DesktopFaireDirectPerksCard";
import { MobileFaireDirectPerksCard } from "@faire/retailer/views/product/Components/MobileFaireDirectPerksCard";
import { ProductPerksCard } from "@faire/retailer/views/product/Components/ProductPerksCard";
import { Customization } from "@faire/retailer/views/product/ProductDetails/AddToCart/Customization";
import { OptionSelection } from "@faire/retailer/views/product/ProductDetails/AddToCart/OptionSelection/OptionSelection";
import { PreorderMessage } from "@faire/retailer/views/product/ProductDetails/AddToCart/PreorderMessage";
import { trackAddToCartEvent, trackEditQuantityEvent, trackSKUViewEvent, trackTaxonomyProductLanguageOptions, trackViewRequestSamplesCTAEvent } from "@faire/retailer/views/product/ProductDetails/AddToCart/TrackEvents";
import { ShippingDetailsList } from "@faire/retailer/views/product/ProductDetails/ShippingDetailsList";
import { VariantLevelInfo } from "@faire/retailer/views/product/ProductDetails/VariantLevelInfo";
import { getProductDetails, getProductOptions } from "@faire/retailer/views/product/utils/productUtils";
import { productWholesalePrice } from "../productWholesalePrice";
import { AddToCartButton } from "./__internal__/ProductAddToCart/AddToCartButton";
import { QuantitySelector } from "./__internal__/ProductAddToCart/QuantitySelector";
import { TesterCheckbox } from "./__internal__/ProductAddToCart/TesterCheckbox";
var ProductAddToCartBase = function(param) {
    var brand = param.brand, product = param.product, productAddToCartState = param.productAddToCartState, productAddCTAOverride = param.productAddCTAOverride, containingModalElement = param.containingModalElement, isInvoice = param.isInvoice, preselectedProductOptionToken = param.preselectedProductOptionToken, sampleDetails = param.sampleDetails, onChangeQuantity = param.onChangeQuantity, onAddToCart = param.onAddToCart, afterAddToCart = param.afterAddToCart, variant = param.variant, isCartInfoLoading = param.isCartInfoLoading, allowCustomOption = param.allowCustomOption, importShipmentInfo = param.importShipmentInfo, infoTexts = param.infoTexts, showSideCart = param.showSideCart;
    var _product_purchase_information_customizations, _product_purchase_information, _productAddToCartState_productPromotionState;
    var typedContext = React.useContext(TrackedLinkContext);
    var isLoggedInRetailerOrBrandPreview = useIsLoggedInRetailerOrBrandPreview();
    var _useFaireProtection = useFaireProtection(), isBrandTokenForbidden = _useFaireProtection.isBrandTokenForbidden, isFaireProtectionLoading = _useFaireProtection.isLoading;
    var isPreOrderExcludedForBrandPromo = useMarketStore([
        "isPreOrderExcludedForBrandPromo"
    ]).isPreOrderExcludedForBrandPromo;
    var _useZustandLocation = useZustandLocation(function(param) {
        var search = param.search, pathname = param.pathname;
        return {
            search: search,
            pathname: pathname
        };
    }), search = _useZustandLocation.search, pathname = _useZustandLocation.pathname;
    var isLoggedInRetailer = useIsLoggedInRetailer();
    var strictLocalize = useStrictLocalization().strictLocalize;
    var wholesalePrice = productWholesalePrice(strictLocalize, getProductDetails(product), false, productAddToCartState.selectedOption, productAddToCartState.perStyleOptionVariations);
    var _useState = _sliced_to_array(useState(false), 2), addToCartNotificationInProgress = _useState[0], setAddToCartNotificationInProgress = _useState[1];
    var _useState1 = _sliced_to_array(useState(false), 2), showUnderMOQPerStyleError = _useState1[0], setShowUnderMOQPerStyleError = _useState1[1];
    var _useState2 = _sliced_to_array(useState(false), 2), shouldShowSampleRequestModal = _useState2[0], setShouldShowSampleRequestModal = _useState2[1];
    var _useState3 = _sliced_to_array(useState([]), 2), subscribedBackInStockTokens = _useState3[0], setSubscribedBackInStockTokens = _useState3[1];
    var backOrderedProductOptionTokens = getProductOptions(product).filter(function(option) {
        return option.state === IProduct.State.SALES_PAUSED && option.token !== undefined;
    }).map(function(option) {
        var _option_token;
        return (_option_token = option.token) !== null && _option_token !== void 0 ? _option_token : "";
    });
    var _useQuerySubscribedBackInStock = useQuerySubscribedBackInStock(getRetailerToken(), QueryParameters.build({
        product_option_tokens: backOrderedProductOptionTokens
    }), {
        enabled: isLoggedInRetailer
    }), subscribedBackInStockData = _useQuerySubscribedBackInStock.data;
    useEffect(function() {
        if (subscribedBackInStockData === null || subscribedBackInStockData === void 0 ? void 0 : subscribedBackInStockData.product_option_tokens) {
            setSubscribedBackInStockTokens(subscribedBackInStockData.product_option_tokens);
        }
    }, [
        subscribedBackInStockData === null || subscribedBackInStockData === void 0 ? void 0 : subscribedBackInStockData.product_option_tokens
    ]);
    useEffect(function() {
        AddToCartNotificationFinished.subscribe(turnOffAddToCartNotification);
        return function() {
            AddToCartNotificationFinished.unsubscribe(turnOffAddToCartNotification);
        };
    }, []);
    useEffect(function() {
        return function() {
            if ("cleanup" in productAddToCartState && typeof productAddToCartState.cleanup === "function") {
                productAddToCartState.cleanup();
            }
        };
    }, [
        productAddToCartState
    ]);
    var viewSampleButtonRef = useDoActionWhenVisible(function() {
        // send view event only if it is part of pilot group or in treatment group
        trackViewRequestSamplesCTAEvent(brand.token, product.token);
    });
    var turnOffAddToCartNotification = function() {
        setAddToCartNotificationInProgress(false);
    };
    var updateCart = function() {
        trackCartAddToCartWebCujClick();
        if (getIsBrandPreview()) {
            return Promise.reject();
        }
        var isOpenSizingVariant = productAddToCartState.isOpenSizingVariant, getIsUnderPerStyleMOQ = productAddToCartState.getIsUnderPerStyleMOQ, areAllOptionQuantitiesValid = productAddToCartState.areAllOptionQuantitiesValid, selectedQuantity = productAddToCartState.selectedQuantity, productOptionInCart = productAddToCartState.productOptionInCart;
        var isUnderPerStyleMOQ = getIsUnderPerStyleMOQ();
        if (isOpenSizingVariant && (isUnderPerStyleMOQ || !areAllOptionQuantitiesValid)) {
            if (isUnderPerStyleMOQ) {
                setShowUnderMOQPerStyleError(true);
            }
            return Promise.reject();
        }
        setShowUnderMOQPerStyleError(false);
        trackEditQuantityEvent(selectedQuantity, productOptionInCart, brand.token, pathname, onChangeQuantity);
        trackAddToCartEvent(search, selectedOption, productOptionInCart, product.token, pathname, typedContext, onAddToCart);
        trackTaxonomyProductLanguageOptions(selectedOption);
        if (isInvoice) {
            return productAddToCartState.addOrUpdateSelectedOptionToInvoice().then(function() {
                afterAddToCart === null || afterAddToCart === void 0 ? void 0 : afterAddToCart();
            });
        }
        return productAddToCartState.addOrUpdateSelectedOptionToCart(getWindowOrThrow().performance.now(), variant).then(function() {
            setAddToCartNotificationInProgress(showSideCart ? false : true);
            // Invoke the after add to cart method if passed down from parent
            afterAddToCart === null || afterAddToCart === void 0 ? void 0 : afterAddToCart();
            trackCartAddToCartWebCujClickTraceUalComplete();
        });
    };
    var deleteBackInStockNotification = function() {
        var selectedOption = productAddToCartState.selectedOption, deleteBackInStockNotification = productAddToCartState.deleteBackInStockNotification;
        deleteBackInStockNotification();
        if (subscribedBackInStockTokens) {
            var updatedTokens = subscribedBackInStockTokens.filter(function(token) {
                return token !== (selectedOption === null || selectedOption === void 0 ? void 0 : selectedOption.token);
            });
            setSubscribedBackInStockTokens(updatedTokens);
        }
    };
    var onTesterCheckboxChange = function() {
        var setIncludesTesters = productAddToCartState.setIncludesTesters, includesTesters = productAddToCartState.includesTesters;
        setIncludesTesters(!includesTesters);
    };
    var isPreorderExcludedFromPromo = function() {
        var _brand_active_promo_collections;
        var promoCollections = (_brand_active_promo_collections = brand.active_promo_collections) !== null && _brand_active_promo_collections !== void 0 ? _brand_active_promo_collections : [];
        return promoCollections.some(function(promoCollection) {
            return isPreOrderExcludedForBrandPromo(promoCollection.promotional_event_key, promoCollection.product_ship_availability);
        });
    };
    var includesTesters = productAddToCartState.includesTesters, minimumOrderQuantity = productAddToCartState.minimumOrderQuantity, isOpenSizingVariant = productAddToCartState.isOpenSizingVariant, currentStyleHasOnlyPrePacks = productAddToCartState.currentStyleHasOnlyPrePacks, selectedOption = productAddToCartState.selectedOption, perStyleOptionVariations = productAddToCartState.perStyleOptionVariations;
    return /*#__PURE__*/ _jsxs(_Fragment, {
        children: [
            shouldShowSampleRequestModal && brand.token !== undefined ? /*#__PURE__*/ _jsx(React.Suspense, {
                fallback: null,
                children: /*#__PURE__*/ _jsx(SamplesRequestStoreProvider, {
                    children: /*#__PURE__*/ _jsx(LazySamplesRequestModal, {
                        brandToken: brand.token,
                        productToken: product.token,
                        source: "PDP",
                        onClose: function() {
                            setShouldShowSampleRequestModal(false);
                        }
                    })
                })
            }) : null,
            /*#__PURE__*/ _jsxs(Wrapper, {
                children: [
                    /*#__PURE__*/ _jsx(OptionSelection, {
                        productAddToCartState: productAddToCartState,
                        product: product,
                        brand: brand,
                        selectedProductOptionToken: preselectedProductOptionToken
                    }),
                    /*#__PURE__*/ _jsx(VariantLevelInfo, {
                        product: product,
                        selectedOption: selectedOption,
                        productAddToCartState: productAddToCartState,
                        actionWhenSKUVisible: function() {
                            trackSKUViewEvent(selectedOption, isOpenSizingVariant, currentStyleHasOnlyPrePacks, product);
                        }
                    }),
                    isLoggedInRetailerOrBrandPreview && ((_product_purchase_information = product.purchase_information) === null || _product_purchase_information === void 0 ? void 0 : (_product_purchase_information_customizations = _product_purchase_information.customizations) === null || _product_purchase_information_customizations === void 0 ? void 0 : _product_purchase_information_customizations.map(function(param, i) {
                        var token = param.token, required = param.required, additional_charge = param.additional_charge, instructions = param.instructions, retailer_input_max_chars = param.retailer_input_max_chars, active = param.active, additional_promo_charge = param.additional_promo_charge;
                        return token && active ? /*#__PURE__*/ _jsxs(React.Fragment, {
                            children: [
                                /*#__PURE__*/ _jsx(Customization, {
                                    required: !!required,
                                    additionalCharge: moneyOrZero(additional_charge),
                                    additionalPromoCharge: additional_promo_charge,
                                    instructions: instructions || "",
                                    characterLimit: retailer_input_max_chars,
                                    value: productAddToCartState.getCustomization(token),
                                    onChange: function(v) {
                                        return productAddToCartState.setCustomization(token, v);
                                    },
                                    onToggle: function(v) {
                                        return productAddToCartState.setCustomizationUsedInMoqCalculation(token, v);
                                    },
                                    wholesalePrice: wholesalePrice !== null && wholesalePrice !== void 0 ? wholesalePrice : ""
                                }),
                                /*#__PURE__*/ _jsx(Spacer, {
                                    size: "2x"
                                })
                            ]
                        }, token || i) : null;
                    })),
                    isLoggedInRetailerOrBrandPreview || isInvoice ? /*#__PURE__*/ _jsxs(_Fragment, {
                        children: [
                            /*#__PURE__*/ _jsx(TesterCheckbox, {
                                product: product,
                                includesTesters: includesTesters,
                                selectedOption: selectedOption,
                                perStyleOptionVariations: perStyleOptionVariations,
                                onTesterCheckboxChange: onTesterCheckboxChange
                            }),
                            isOpenSizingVariant ? null : /*#__PURE__*/ _jsx(QuantitySelector, {
                                productAddToCartState: productAddToCartState,
                                product: product,
                                subscribedBackInStockTokens: subscribedBackInStockTokens,
                                allowCustomOption: allowCustomOption,
                                containingModalElement: containingModalElement,
                                deleteBackInStockNotification: deleteBackInStockNotification
                            }),
                            /*#__PURE__*/ _jsx(Spacer, {
                                height: "1x"
                            }),
                            /*#__PURE__*/ _jsx(AddToCartButton, {
                                brandToken: brand.token,
                                addToCartNotificationInProgress: addToCartNotificationInProgress,
                                isBrandActive: brand.active,
                                isInvoice: isInvoice,
                                isCartInfoLoading: isCartInfoLoading,
                                isFaireProtectionLoading: isFaireProtectionLoading,
                                productAddToCartState: productAddToCartState,
                                product: product,
                                productAddCTAOverride: productAddCTAOverride,
                                updateCart: updateCart,
                                isBrandTokenForbidden: isBrandTokenForbidden
                            }),
                            sampleDetails ? /*#__PURE__*/ _jsxs(RequestSampleViewRefWrapper, {
                                ref: viewSampleButtonRef,
                                children: [
                                    /*#__PURE__*/ _jsx(Spacer, {
                                        size: "2x"
                                    }),
                                    /*#__PURE__*/ _jsx(RequestASampleButton, {
                                        "data-test-id": "request-samples-button-pdp",
                                        onClick: function() {
                                            setShouldShowSampleRequestModal(true);
                                        },
                                        children: /*#__PURE__*/ _jsx(StrictLocalMsg, {
                                            id: "0KSIcj",
                                            defaultMessage: [
                                                {
                                                    type: 0,
                                                    value: "Request a sample"
                                                }
                                            ]
                                        })
                                    })
                                ]
                            }) : null,
                            showUnderMOQPerStyleError ? /*#__PURE__*/ _jsxs(_Fragment, {
                                children: [
                                    /*#__PURE__*/ _jsx(Spacer, {
                                        size: "2x"
                                    }),
                                    /*#__PURE__*/ _jsx(OpenSizingErrorMessage, {
                                        children: /*#__PURE__*/ _jsx(StrictLocalMsg, {
                                            id: "kf83F6",
                                            defaultMessage: [
                                                {
                                                    type: 0,
                                                    value: "This item requires a minimum order quantity of "
                                                },
                                                {
                                                    type: 1,
                                                    value: "minimumOrderQuantityNumber"
                                                }
                                            ],
                                            values: {
                                                minimumOrderQuantityNumber: minimumOrderQuantity
                                            }
                                        })
                                    })
                                ]
                            }) : null,
                            productAddToCartState.showPreorderMessaging ? /*#__PURE__*/ _jsx(PreorderMessage, {
                                isOpenSizingVariant: productAddToCartState.isOpenSizingVariant,
                                openSizingShipDateRange: productAddToCartState.openSizingShipDateRange,
                                openSizingAllSameDates: productAddToCartState.openSizingAllSameDates,
                                baseOrderByDate: productAddToCartState.baseOrderByDate,
                                selectedOption: productAddToCartState.selectedOption,
                                product: product,
                                isPreorderExcludedFromPromo: isPreorderExcludedFromPromo()
                            }) : null
                        ]
                    }) : /*#__PURE__*/ _jsxs(_Fragment, {
                        children: [
                            /*#__PURE__*/ _jsx(ShippingDetailsList, {
                                brand: brand,
                                importShipmentInfo: importShipmentInfo,
                                infoTexts: infoTexts,
                                shippingPromotion: (_productAddToCartState_productPromotionState = productAddToCartState.productPromotionState) === null || _productAddToCartState_productPromotionState === void 0 ? void 0 : _productAddToCartState_productPromotionState.guaranteedFreeShippingPromo,
                                isPreorder: productAddToCartState.showPreorderMessaging
                            }),
                            /*#__PURE__*/ _jsx(Spacer, {
                                size: "3x"
                            }),
                            /*#__PURE__*/ _jsx(MaybePerksCard, {})
                        ]
                    })
                ]
            })
        ]
    });
};
var MaybePerksCard = function() {
    var settingFaireDirectPDPSignup = useSettingFaireDirectPDPSignup();
    var isFaireDirectActiveInLoggedOut = useFaireDirectBrand().isFaireDirectActiveInLoggedOut;
    if (isFaireDirectActiveInLoggedOut) {
        return !settingFaireDirectPDPSignup ? /*#__PURE__*/ _jsx(ResponsiveContentV2, {
            mobile: /*#__PURE__*/ _jsx(MobileFaireDirectPerksCard, {}),
            tabletAndAbove: /*#__PURE__*/ _jsx(DesktopFaireDirectPerksCard, {})
        }) : null;
    }
    return /*#__PURE__*/ _jsx(ProductPerksCard, {});
};
export var ProductAddToCart = observer(ProductAddToCartBase);
var Wrapper = styled(Column).attrs({
    align: "flex-start"
}).withConfig({
    componentId: "sc-7b4dc630-0"
})([
    "width:100%;"
]);
var RequestASampleButton = styled(Button).attrs({
    variant: "secondary"
}).withConfig({
    componentId: "sc-7b4dc630-1"
})([
    "width:100%;"
]);
var OpenSizingErrorMessage = styled(Typography).attrs({
    color: Core.text.critical
}).withConfig({
    componentId: "sc-7b4dc630-2"
})([
    "&&&{margin-top:2px;}"
]);
var RequestSampleViewRefWrapper = styled.div.withConfig({
    componentId: "sc-7b4dc630-3"
})([
    "width:100%;"
]);
